import React from 'react';
import useIsLoginContext from '@/lib/hooks/useIsLoginContext';
import { createContext } from 'react';

export const UserContext = createContext({});

const UserContextProvider = ({ children }) => {
  return <UserContext.Provider value={useIsLoginContext()}>{children}</UserContext.Provider>;
};

export default UserContextProvider;
